import React from 'react';
import { withStyles } from 'material-ui/styles';
import Dialog, {withResponsiveFullScreen} from 'material-ui/Dialog';
import Slide from 'material-ui/transitions/Slide';
import HandlersDialogHookStep from './handlers_dialog_hook_step.js';
import HandlersDialogExctractorStep from './handlers_dialog_extractor_step.js';
import HandlersDialogRendererStep from './handlers_dialog_renderer_step.js';

const styles = {
  root:{
    height: '100%',
  },
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
};

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class HandlersDialog extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      open: false,
      step: 1,
      hook: null,
      extractor: null,
      renderer: null,
    }

    this.handleRequestClose = this.handleRequestClose.bind(this);
    this.handleSelected = this.handleSelected.bind(this);
    this.handleSelectedHook = this.handleSelectedHook.bind(this);
    this.handleSelectedExtractor = this.handleSelectedExtractor.bind(this);
    this.handleSelectedRenderer = this.handleSelectedRenderer.bind(this);
  }

  doShow(){
    this.setState({open : true});
  }

  handleSelectedHook(selection){
    this.setState({hook: selection, step: 2});
  }

  handleSelectedExtractor(selection){
    this.setState({extractor: selection, step: 3});
  }

  handleSelectedRenderer(selection){
    const $this = this;
    this.setState({renderer: selection}, function(){$this.handleSelected();});
  }

  handleSelected(){
    if(this.props.onSelected){     
      this.props.onSelected({
            name : this.state.hook,
            type : this.state.renderer.type,
            renderer : this.state.renderer.name,
            extractor: this.state.extractor,
          });
    }
    this.handleRequestClose()
  }

  handleRequestClose(){
    this.setState({open : false, step: 1});
  }
  
  componentDidMount() {
    this.props.onRef(this)
    this.setState({step : 1});
  }
  
  componentWillUnmount() {
    this.props.onRef(null)
  }

  render() {
    const classes = this.props.classes;
    return (
      <Dialog
        className={classes.root}
        fullScreen
        open={this.state.open}
        onRequestClose={this.handleRequestClose}
        transition={Transition}>
        {this.state.step === 1 && 
          <HandlersDialogHookStep onSelected={this.handleSelectedHook} onClose={this.handleRequestClose} item={this.props.item}/>
        }
        {this.state.step === 2 && 
          <HandlersDialogExctractorStep onSelected={this.handleSelectedExtractor} onClose={this.handleRequestClose} item={this.props.item}/>
        }
        {this.state.step === 3 && 
          <HandlersDialogRendererStep onSelected={this.handleSelectedRenderer} onClose={this.handleRequestClose} item={this.props.item}/>
        }
    </Dialog>      
    );
  }
}

const ResponsiveDialog = withResponsiveFullScreen()(HandlersDialog);
export default withStyles(styles)(ResponsiveDialog);


// WEBPACK FOOTER //
// ./src/search/admin/handlers_dialog.js